export default {
  applicationName: 'Golden Acorn',
  privacyURL: null, //If specified it will appear on registration and any other pre- authorization box for the user. -- Privacy and Help URLs are required in order to make this visible. 
  helpURL: null, //If specified it will appear on registration and any other pre - authorization box for the user. -- Privacy and Help URLs are required in order to make this visible. 
  termsURL: null, //If specified it will appear on registration and any other pre - registration box for the user. -- Privacy and Terms URLs are required in order to make this visible.
  hidePhoneNumberField: true,
  signupEnabled: true
}